import { render, staticRenderFns } from "./list-photo.vue?vue&type=template&id=4baf0e62&scoped=true"
import script from "./list-photo.vue?vue&type=script&lang=ts"
export * from "./list-photo.vue?vue&type=script&lang=ts"
import style0 from "./list-photo.vue?vue&type=style&index=0&id=4baf0e62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf0e62",
  null
  
)

export default component.exports